import styled from 'styled-components';

export const Detail = styled.div`
  background-color: ${({ theme }) => theme.colors.white};

  margin-top: 0.5rem;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  :nth-child(2) {
    > div:not(:last-child) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    > div {
      display: grid;
      grid-template-columns: 1fr;
    }

    :nth-child(2) {
      > div:not(:last-child) {
        display: grid;
        grid-template-columns: 1fr;
      }
    }
  }
`;

export const DetailContainerTitle = styled.span`
  font-family: Source Sans Pro;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.grayDark3};
  margin-bottom: 0.5rem;
`;

export const DetailContentRow = styled.div`
  display: flex;

  gap: 1.5rem;
`;

export const DetailCardContainer = styled.div`
  display: flex;
  flex-direction: column;

  min-width: 10.75rem;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const DetailCardText = styled.span<{
  bold?: boolean;
}>`
  font-family: Work Sans;
  font-weight: ${({ bold }) => (bold ? '600' : '400')};
  font-size: ${({ bold }) => (bold ? '16' : '14')}px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
